export const ArrowIcon = ({ className }: { className?: string }) => {
  return (
    <svg className={`${className} stroke-current w-5 h-5`} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path className="stroke-current" d="M14.6682 5.85189L5.8294 14.6907" strokeWidth="1.4985" strokeLinecap="round" strokeLinejoin="round" />
      <path className="stroke-current" d="M7.5524 5.86685L14.6671 5.85153L14.6523 12.9668" strokeWidth="1.4985" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
